<ion-header class="project-header">
    <ion-toolbar>
        <div class="header-copy">
            <h1 class="title">{{ HeaderTitle }}</h1>
            <p class="subtitle" *ngIf="Subtitle">{{ Subtitle }}</p>
        </div>
        <ion-button *ngIf="ShowClose" slot="end" fill="clear" color="dark" shape="round" class="close-btn"
            (click)="Close()" aria-label="Fechar">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
    <ion-toolbar *ngIf="ShowSearch" class="search-toolbar">
        <ion-searchbar #search [placeholder]="SearchPlaceholder" [value]="SearchText"
            (ionInput)="OnSearch($event)"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <cdk-virtual-scroll-viewport class="projects-viewport ion-content-scroll-host" itemSize="60" minBufferPx="600"
        maxBufferPx="1200">
        <ng-container *cdkVirtualFor="let item of FilteredEntities; trackBy: trackByFn">
            <ion-item button detail="false" lines="none" class="project-item" [class.selected]="IsSelected(item)"
                (click)="Toggle(item)">
                <span class="monogram" slot="start" [class.on]="IsSelected(item)"
                    aria-hidden="true">{{ item?.Mono }}</span>
                <div class="project-info">
                    <span class="project-name">{{ item?.Name || '--' }}</span>
                    <span class="project-id" [class.copied]="CopiedId === item?.Id" title="Copiar Id"
                        (click)="$event.stopPropagation(); CopyId(item)">
                        {{ CopiedId === item?.Id ? 'Id copiado' : ('ID ' + item?.Id) }}
                    </span>
                </div>
                <ion-icon *ngIf="IsSelected(item)" slot="end" name="checkmark-outline" class="row-check"
                    aria-hidden="true"></ion-icon>
            </ion-item>
        </ng-container>

        <div class="empty" *ngIf="FilteredEntities?.length == 0">
            <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
            <p>Sem {{ NounPlural }} para «{{ SearchText }}».</p>
        </div>
    </cdk-virtual-scroll-viewport>
</ion-content>

<ion-footer class="project-footer">
    <ion-toolbar>
        <span class="count" slot="start">
            <ng-container *ngIf="Multiple">{{ SelectedCount }} selecionado{{ SelectedCount === 1 ? '' : 's' }}</ng-container>
            <ng-container *ngIf="!Multiple && IsFiltering">{{ ShownCount }} de {{ TotalCount }} {{ NounPlural }}</ng-container>
            <ng-container *ngIf="!Multiple && !IsFiltering">{{ TotalCount }} {{ NounPlural }}</ng-container>
        </span>
        <ion-button *ngIf="HasPriorSelection" slot="end" fill="clear" color="medium" class="cancel-btn"
            (click)="Close()">
            Cancelar
        </ion-button>
        <ion-button slot="end" fill="solid" color="primary" [disabled]="!HasSelection" (click)="Confirm()">
            {{ ConfirmText }}
            <ion-icon slot="end" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-footer>
